import { apiSlice } from './apiSlice';
import { OPENINGSTOCKS_URL } from '../constants';

export const openingStocksApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create a new openingStock
    createOpeningStock: builder.mutation({
      query: (openingStock) => ({
        url: OPENINGSTOCKS_URL,
        method: 'POST',
        body: openingStock,
      }),
      invalidatesTags: ['OpeningStocks'], // Ensures the cache is updated
    }),
    // Get openingStock details by ID
    getOpeningStockDetails: builder.query({
      query: (id) => ({
        url: `${OPENINGSTOCKS_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
      providesTags: (result, error, id) => [{ type: 'OpeningStock', id }], // Cache tag for individual openingStock
    }),
    // Get logged-in user's openingStocks
    getMyOpeningStocks: builder.query({
      query: () => ({
        url: `${OPENINGSTOCKS_URL}/mine`,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['MyOpeningStocks'], // Cache tag for the user's openingStocks
    }),
    // Get all openingStocks (Admin view)
    getOpeningStocks: builder.query({
      query: () => ({
        url: OPENINGSTOCKS_URL,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['OpeningStocks'], // Cache tag for admin openingStocks
    }),
    // Mark a openingStock as delivered (Admin action)
    deliverOpeningStock: builder.mutation({
      query: (openingStockId) => ({
        url: `${OPENINGSTOCKS_URL}/${openingStockId}/deliver`,
        method: 'PUT',
      }),
      invalidatesTags: (result, error, openingStockId) => [{ type: 'OpeningStock', id: openingStockId }], // Invalidates cache for delivered openingStock
    }),
    // Delete a openingStock (Admin action)
    deleteOpeningStock: builder.mutation({
      query: (openingStockId) => ({
        url: `${OPENINGSTOCKS_URL}/${openingStockId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, openingStockId) => [{ type: 'OpeningStock', id: openingStockId }, 'OpeningStocks'], // Updates openingStock cache
    }),
  }),
});

export const {
  useCreateOpeningStockMutation,
  useGetOpeningStockDetailsQuery,
  useGetMyOpeningStocksQuery,
  useGetOpeningStocksQuery,
  useDeliverOpeningStockMutation,
  useDeleteOpeningStockMutation,
} = openingStocksApiSlice;